import getConfig from 'next/config';

const { publicRuntimeConfig: { recaptchaSiteKey } } = getConfig();

export const executeRecaptcha = (action: string) => {
  if (typeof window === 'undefined' || !window.grecaptcha?.execute) return null;

  try {
    return window.grecaptcha.execute(recaptchaSiteKey, { action });
  }
  catch(e) {
    return null;
  }

}